export default __webpack_public_path__ + "static/media/pen.463bcde5.ogg";